import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Grid, TextField, Typography, Avatar } from '@mui/material';
import FormContainer from 'containers/FormContainer';
import PasswordHelperText from 'components/PasswordHelperText';
import IntlMessages from 'lngProvider/IntlMessages';
import * as Yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { colors, spacing } from 'styles/Common';

const StyledGrid = styled(Grid)((
    {
        theme
    }
    ) => {
        return {
            maxWidth: '300px',
            marginTop: spacing[9],
            '& .MuiInputBase-input': {
                height: 30
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                height: 48
            },
            '& .MuiButton-root': {
                borderRadius: '8px'
            },
            '& .MuiButton-contained.Mui-disabled': {
                backgroundColor: theme.palette.primary.light
            },
            '& .close-icon': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.primary.main,
                height: 40,
                width: 40,
                marginTop: spacing[4]
            },
            '& .title-text': {
                marginTop: spacing[9],
                fontWeight: 600
            },
            '& .subtitle-text': {
                marginTop: spacing[2],
                marginBottom: spacing[6]
            },
            '& .forgot-button': {
                color: colors.fillWhite,
                marginTop: spacing[2],
                marginBottom: spacing[7],
                height: 48,
                '& .MuiButton-contained.Mui-disabled': {
                    backgroundColor: theme.palette.primary.light
                }
            }
        };
});

const ResetPasswordMobile = (props) => {

    const validationSchema = Yup.object().shape({
        newPassword: Yup.string()
            .required(true)
            .min(8, true)
            .matches(
                process.env.REACT_APP_PASSWORD_REGEX,
                true),
        confirmNewPassword: Yup.string()
            .required(true)
            .oneOf([Yup.ref('newPassword')], true)
    });

    const { data, onSubmit, loginConfig, intl } = props;

    const loginUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return `/app/login?ReturnUrl=${encodeURIComponent(params.returnUrl)}`;
    }

    return (
        <FormContainer
            initialValues={data || this.defaultState}
            validationSchema={validationSchema}
            onSubmit={onSubmit}>

        {props => {
            const {
                values,
                errors,
                touched,
                isSubmitting,
                handleChange,
                handleBlur
            } = props;

            return (
                <StyledGrid>
                    <Grid container>
                        <Link to={loginUrl()}><Avatar className="close-icon"><CloseIcon /></Avatar></Link>
                        <Grid item xs={12}>
                            <Typography
                                variant="h4"
                                className="title-text">
                                <IntlMessages id={loginConfig.resetPasswordTitle} />
                            </Typography>
                        </Grid>
                        {values.showError === false ?
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" className="subtitle-text"><IntlMessages id={loginConfig.resetPasswordSubTitle} /></Typography>
                            </Grid>
                        : ''}
                    </Grid>

                    {values.showError === false ?
                        <Grid container spacing={2}>

                            <Grid item xs={12}>

                                <TextField
                                    value={values.newPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.newPassword && touched.newPassword}
                                    FormHelperTextProps={{ component: 'div', margin: 'dense' }}
                                    helperText={errors.newPassword || touched.newPassword ? <PasswordHelperText data={values} /> : ""}
                                    type="password"
                                    name="newPassword"
                                    maxLength="256"
                                    placeholder={intl.formatMessage({ id: 'resetPassword.password' })}
                                    inputProps={{ maxLength: 256 }}
                                    className="text-field"
                                    fullWidth />

                            </Grid>

                            <Grid item xs={12}>

                                <TextField
                                    value={values.confirmNewPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.confirmNewPassword && touched.confirmNewPassword}
                                    helperText={(errors.confirmNewPassword && touched.confirmNewPassword) ? <IntlMessages id="changePassword.newAndConfirmDoNotMatchShort" /> : ""}
                                    type="password"
                                    name="confirmNewPassword"
                                    maxLength="256"
                                    placeholder={intl.formatMessage({ id: 'resetPassword.confirmPassword' })}
                                    inputProps={{ maxLength: 256 }}
                                    className="text-field"
                                    fullWidth />

                            </Grid>

                            <Grid item xs={12}>

                                <Button
                                    type="submit"
                                    color="primary"
                                    fullWidth
                                    className="forgot-button"
                                    disabled={isSubmitting ||
                                        errors.newPassword ||
                                        errors.confirmNewPassword ||
                                        values.newPassword === '' ||
                                        values.confirmNewPassword === '' ||
                                        values.newPassword !== values.confirmNewPassword}>

                                    <IntlMessages id="resetPassword.submit" />

                                </Button>

                            </Grid>

                        </Grid>
                        :
                        ''}

                    {values.showError === true
                        ?
                        <Grid container spacing={4}>

                            <Grid item xs={12}>

                                <Typography variant="body1" dangerouslySetInnerHTML={{ __html: values.missingCodeMessage }}></Typography>

                            </Grid>

                        </Grid>
                        :
                        ''}

                </StyledGrid>
            );
        }}
    </FormContainer>
    );
}

export default ResetPasswordMobile;